import React from "react";

import TaskModal from "components/pages/transmissions/modal/patient/tabs/generalInformation/tabs/task/modal/TaskModal";
import usePatientTasks from "components/pages/transmissions/modal/patient/tabs/generalInformation/tabs/task/usePatientTasks";
import PatientTaskTable from "components/pages/transmissions/modal/patient/tabs/generalInformation/tabs/task/table/PatientTaskTable";

const PatientTasks = () => {
  const { isPatientTaskModal } = usePatientTasks();

  return (
    <div className="patient-modal__section">
      <div className="patient-form__row">
        <div className="patient-form__col--full">
          <PatientTaskTable />
          {isPatientTaskModal && <TaskModal />}
        </div>
      </div>
    </div>
  );
};

export default PatientTasks;
